<template>
  <div v-if="actor.component === 'OTEPriceChart'">
    <div class="text-left py-3">Graf využití hodinových cen</div>
    <o-t-e-price-chart :actor="actor" />
  </div>
  <div v-else-if="actor.component === 'StructDisplayList'">
    <struct-display-list :actor="actor" />
  </div>
  <b-row v-else align-h="center">
    <b-col cols="6" class="text-left">
      <span v-if="showTitle" class="mr-3">
        {{ actor.title }}
      </span>
      <inline-help
        v-if="showTitle && actor.description && actor.description !== actor.title"
        :id="`status-help-${actor.id}`"
        :title="(currentSnapshot.rev === 2 ? actor.title : actor.name)"
        :description="actor.description"
      />
    </b-col>
    <b-col cols="6" class="text-right">
      <display-status-value :actor="actor" />
    </b-col>
  </b-row>
</template>

<script>
import DisplayStatusValue from '@/components/services/service/DisplayStatusValue';
import { mapState } from 'vuex';
import InlineHelp from '@/components/services/service/InlineHelp';

export default {
  name: 'Status',
  components: { InlineHelp, DisplayStatusValue },
  props: {
    actor: {
      type: Object,
      required: true,
    },
    showTitle: Boolean,
  },
  computed: {
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
  },
};
</script>

<style scoped>
</style>
